import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environmentOm } from 'src/environment-om';

@Component({
    selector: 'om-app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {
    constructor(titleService: Title) {
        let title = 'One Map';
        if (environmentOm.titleAddition) {
            title += environmentOm.titleAddition;
        }
        titleService.setTitle(title);
    }
}
